module.exports = __webpack_public_path__ + "img/map-gfpt.d2e7e4d3.png";